const Error404 = () => {
    return <div className="text-white text-center">UNAUTHORIZED</div>
}

export default Error404;